module.exports = __webpack_public_path__ + "img/m.2a3dbafb.webp";